import NavProfileIcon from "../../../media/icons/nav_profile.svg?react"
import NavClientsIcon from "../../../media/icons/nav_clients.svg?react"
import NavEmptyLegsIcon from "../../../media/icons/nav_empty_legs.svg?react"
import NavFindRequestIcon from "../../../media/icons/nav_find_request.svg?react"
import NavMyRequestsIcon from "../../../media/icons/nav_my_requests.svg?react"
import NavMyRespondsIcon from "../../../media/icons/nav_my_responds.svg?react"
import NavFleetIcon from "../../../media/icons/nav_fleet.svg?react"
import NavCreateRequestIcon from "../../../media/icons/nav_create_request.svg?react"
import NavCalendarIcon from "../../../media/icons/nav_calendar.svg?react"
import NavDocumentIcon from "../../../media/icons/document.svg?react"
import {ReactNode} from "react";
import {newTripRequest} from "./lk/lkCharterer/newTripRequest";
import {requests} from "./lk/lkCharterer/requests";
import {requestsFromClients} from "./lk/lkCharterer/requestsFromClients";
import {requestsFromAgents} from "./lk/lkFreighter/requestsFromAgents";
import {emptyLegs} from "./lk/lkFreighter/emptyLegs";
import {profile} from "./lk/lkCommon/profile";
import {searchEmptyLegs} from "./lk/lkCharterer/searchEmptyLegs";
import {eventCalendar} from "./lk/lkFreighter/eventCalendar";
import {adminRegistrations} from "./lk/lkAdmin/adminRegistrations";
import {adminPlaneApprovals} from "./lk/lkAdmin/adminPlaneApprovals";
import {adminCurrencies} from "./lk/lkAdmin/adminCurrencies";
import {PageGroupMessages} from "./PageGroupMessages";

// Define PageGroups enum here to avoid circular dependency
export enum PageGroups {
  FLEET,
  PROFILE,
}

// Export PageGroupMessages
export {PageGroupMessages};

export const PageGroupIconByPageGroup = new Map<PageGroups, ReactNode>()
  .set(PageGroups.FLEET, <NavFleetIcon />)
  .set(PageGroups.PROFILE, <NavProfileIcon />)

export const PageIconByPagePath = new Map<string, ReactNode>()
  .set(newTripRequest.path, <NavCreateRequestIcon />)
  .set(requests.path, <NavMyRequestsIcon />)
  .set(requestsFromClients.path, <NavClientsIcon />)
  // .set(tripBoard.path, <NavFindRequestIcon />)
  .set(emptyLegs.path, <NavEmptyLegsIcon />)
  .set(requestsFromAgents.path, <NavMyRespondsIcon />)
  .set(eventCalendar.path, <NavCalendarIcon />)
  .set(profile.path, <NavProfileIcon />)
  .set('/lk/settings', <NavProfileIcon />)
  .set('/lk/message-templates', <NavProfileIcon />)
  .set('/lk/subscription', <NavProfileIcon />)
  .set(searchEmptyLegs.path, <NavEmptyLegsIcon />)
  .set(adminRegistrations.path, <NavDocumentIcon />)
  .set(adminPlaneApprovals.path, <NavFleetIcon />)
  .set(adminCurrencies.path, <NavDocumentIcon />);